/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseNoteHistoryResponse
 */
export interface CaseNoteHistoryResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseNoteHistoryResponse
     */
    caseNoteId: string;
    /**
     * 
     * @type {number}
     * @memberof CaseNoteHistoryResponse
     */
    versionNumber: number;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteHistoryResponse
     */
    content: string;
    /**
     * 
     * @type {Date}
     * @memberof CaseNoteHistoryResponse
     */
    validFromUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseNoteHistoryResponse
     */
    validToUtc: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteHistoryResponse
     */
    correlationId: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteHistoryResponse
     */
    modifiedBy: string;
}

/**
 * Check if a given object implements the CaseNoteHistoryResponse interface.
 */
export function instanceOfCaseNoteHistoryResponse(value: object): value is CaseNoteHistoryResponse {
    if (!('caseNoteId' in value) || value['caseNoteId'] === undefined) return false;
    if (!('versionNumber' in value) || value['versionNumber'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('validFromUtc' in value) || value['validFromUtc'] === undefined) return false;
    if (!('validToUtc' in value) || value['validToUtc'] === undefined) return false;
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    if (!('modifiedBy' in value) || value['modifiedBy'] === undefined) return false;
    return true;
}

export function CaseNoteHistoryResponseFromJSON(json: any): CaseNoteHistoryResponse {
    return CaseNoteHistoryResponseFromJSONTyped(json, false);
}

export function CaseNoteHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseNoteHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'caseNoteId': json['caseNoteId'],
        'versionNumber': json['versionNumber'],
        'content': json['content'],
        'validFromUtc': (new Date(json['validFromUtc'])),
        'validToUtc': (json['validToUtc'] == null ? null : new Date(json['validToUtc'])),
        'correlationId': json['correlationId'],
        'modifiedBy': json['modifiedBy'],
    };
}

export function CaseNoteHistoryResponseToJSON(json: any): CaseNoteHistoryResponse {
    return CaseNoteHistoryResponseToJSONTyped(json, false);
}

export function CaseNoteHistoryResponseToJSONTyped(value?: CaseNoteHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'caseNoteId': value['caseNoteId'],
        'versionNumber': value['versionNumber'],
        'content': value['content'],
        'validFromUtc': value['validFromUtc'].toISOString(),
        'validToUtc': value['validToUtc'] == null ? value['validToUtc'] : value['validToUtc'].toISOString(),
        'correlationId': value['correlationId'],
        'modifiedBy': value['modifiedBy'],
    };
}

